import React, { useLayoutEffect, useRef, useState } from 'react'
import classnames from 'classnames'

import { type ToolbarPosition } from '../common/types'

import { ToolbarLinkPanel } from './link/ToolbarLinkPanel'
import { ToolbarFormattingButtonGroup } from './formatting/ToolbarFormattingButtonGroup'

interface DescriptionFloatingToolbarProps {
  position: ToolbarPosition
  showLinkPanel: boolean
  isBold: boolean
  isItalic: boolean
  isUnderline: boolean
  isLink: boolean
  linkInitialUrl: string
  onBold: () => void
  onItalic: () => void
  onUnderline: () => void
  onLinkClick: () => void
  onLinkConfirm: (url: string) => void
  onLinkUnlink: () => void
  onLinkCancel: () => void
}

const SelectionToolbarDuplexer = ({
  position,
  showLinkPanel,
  isBold,
  isItalic,
  isUnderline,
  isLink,
  linkInitialUrl,
  onBold,
  onItalic,
  onUnderline,
  onLinkClick,
  onLinkConfirm,
  onLinkUnlink,
  onLinkCancel,
}: DescriptionFloatingToolbarProps) => {
  const toolbarRef = useRef<HTMLDivElement>(null)
  const [contentHeight, setContentHeight] = useState(0)

  useLayoutEffect(() => {
    const el = toolbarRef.current
    if (!el) return undefined

    const syncHeight = () => {
      setContentHeight(el.offsetHeight)
    }

    syncHeight()
    const observer = new ResizeObserver(syncHeight)
    observer.observe(el)
    return () => observer.disconnect()
  }, [position.left, position.top, showLinkPanel])

  const handleMouseDown = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault()
  }

  return (
    <div
      ref={toolbarRef}
      className={classnames(
        'description-toolbar',
        showLinkPanel && 'description-toolbar--link'
      )}
      style={{
        top: position.top - contentHeight,
        left: position.left,
      }}
    >
      {showLinkPanel ? (
        <ToolbarLinkPanel
          initialUrl={linkInitialUrl}
          isExistingLink={isLink}
          onConfirm={onLinkConfirm}
          onUnlink={onLinkUnlink}
          onCancel={onLinkCancel}
        />
      ) : (
        <ToolbarFormattingButtonGroup
          isBold={isBold}
          isItalic={isItalic}
          isUnderline={isUnderline}
          isLink={isLink}
          onBold={onBold}
          onItalic={onItalic}
          onUnderline={onUnderline}
          onLinkClick={onLinkClick}
          handleMouseDown={handleMouseDown}
        />
      )}
    </div>
  )
}

export { SelectionToolbarDuplexer as SelectionToolbar }
